import { thousandSeperator } from "@utils/general/digit-separators";
import { formatDate, formatDateTime } from "@utils/general/format-date";
import { formatDBDate } from "@utils/general/format-db-date";

export const productPriceHistoryColumns = () => [
  {
    name: "Product Price",
    selector: (row: any) => thousandSeperator(row.price),
    // center: true,
  },
  {
    name: "User Name",
    selector: (row: any) => `${row.first_name}${row.last_name}`,
    // center: true,
  },
  {
    name: "Date",
    selector: (row: any) =>
      row.start_date ? formatDateTime(row.start_date) : "-",
    // center: true,
  },
];

export const productPriceHistoryColumnNames = ["Credit Limit Amount", "Date"];
